export default "__VITE_ASSET__BJs_oVER__"